import { createStyles } from '@mui/styles';

export const styles = theme =>
  createStyles({
    root: {
      backgroundColor: theme.palette.primary.teal,
      color: theme.palette.primary.white,
      textAlign: 'center',
      fontSize: 16,
      fontWeight: 500,
      padding: 14,
      [`${theme.breakpoints.down('xl')} and (orientation: landscape)`]: {
        padding: 0,
        color: theme.palette.primary.deepBlue,
      },
    },
  });
